import { GraphQLError } from 'graphql';
import { graphql } from 'msw';

import { SocialSignInFacebookMutation } from '../AuthModal/section/SignIn/queries/facebookSignIn.generated';
import { generateUserWithTrackedPropertiesHandler } from './user';

export const generateFacebookHandler = (
    response: SocialSignInFacebookMutation['socialSignInFacebook']
) => {
    return graphql.mutation<SocialSignInFacebookMutation>(
        'socialSignInFacebook',
        (_, res, ctx) => {
            return res(ctx.data({ socialSignInFacebook: response }));
        }
    );
};

export const generateFacebookErrorHandler = (
    errorMessage: GraphQLError['message']
) => {
    const graphqlError = new GraphQLError(errorMessage);

    return graphql.mutation<SocialSignInFacebookMutation>(
        'socialSignInFacebook',
        (_, res, ctx) => {
            return res(ctx.errors([graphqlError]));
        }
    );
};

export const defaultFacebookHandler = generateFacebookHandler({
    success: true
});

export const facebookFailHandler = generateFacebookHandler({
    success: false
});

export const facebookServerErrorHandler =
    generateFacebookErrorHandler('<Error message>');

export const defaultFacebookUserHandler =
    generateUserWithTrackedPropertiesHandler({
        loggedIn: true,
        name: '<test-name>',
        email: '<test-email>',
        status: 'valid',
        senderPropertyStatus: '',
        userId: 32503316,
        userUuid: '<user-id>',
        creationDate: '2020-01-26 11:34:01',
        brandPrimary: 'zoopla',
        registrationSources: ['facebook'],
        registered: true,
        trackedProperties: {
            items: [],
            total: 0
        }
    });

export const facebookNewUserHandler = generateUserWithTrackedPropertiesHandler({
    loggedIn: true,
    name: '<test-name>',
    email: '<test-email>',
    status: 'valid',
    senderPropertyStatus: '',
    userId: 32503316,
    userUuid: '<user-id>',
    creationDate: '2020-01-27 11:34:01',
    brandPrimary: 'zoopla',
    registrationSources: ['facebook'],
    registered: false,
    trackedProperties: {
        items: [],
        total: 0
    }
});

export const facebookNewUserMultiHandler =
    generateUserWithTrackedPropertiesHandler({
        loggedIn: true,
        name: '<test-name>',
        email: '<test-email>',
        status: 'valid',
        senderPropertyStatus: '',
        userId: 32503316,
        userUuid: '<user-id>',
        creationDate: '2020-01-25 11:34:01',
        brandPrimary: 'zoopla',
        registrationSources: ['google', 'facebook'],
        registered: null,
        trackedProperties: {
            items: [],
            total: 0
        }
    });
